// extracted by mini-css-extract-plugin
module.exports = {"view-report":"view-report-d13fba82c381c0422a7e7901f6b6a0cc"};